import FullPageLoading from '@/components/FullPageLoading';
import React, { lazy, Suspense } from 'react';

const MapEditorComponent = lazy(() => import('./BaseTripMapEditor'));

type Props = { baseTripId: string; onClose: () => void };

export default function BaseTripMapEditorContainer(props: Props) {
  return (
    <Suspense fallback={<FullPageLoading />}>
      <MapEditorComponent {...props} />
    </Suspense>
  );
}
